module.exports = Object.freeze({
    BASE: process.env.REACT_APP_BASE_URL || 'http://identeq-app.local:8000',
    DOMAIN: '/domain',
    LOGIN: '/auth/login',
    TWOFA: '/auth/token',

    AZURE_CALLBACK: '/auth/azure/callback',

    ACTIVATE: '/auth/activate',
    ACTIVATE_POST: '/auth/activate/post',

    PRODUCTS: '/products',

    AUDITS: '/audits',

    USAGE: '/usage',

    BOOKMARKS: '/bookmarks',
    SET_BOOKMARK_ORDER: 'bookmarks/order',

    VACANT_COT_ALERTS_GET_CUSTOMER: '/products/vacant-cot-alerts/search',
    VACANT_COT_ALERTS_DATES: '/products/vacant-cot-alerts/dates',
    VACANT_COT_ALERTS_GET_WORKFLOW_DATES: '/products/vacant-cot-alerts/workflow-dates',
    VACANT_COT_ALERTS_SUMMARY: '/products/vacant-cot-alerts',
    VACANT_COT_ALERTS_SUMMARY_BULK: '/products/vacant-cot-alerts/bulk',
    VACANT_COT_ALERTS_BUY_CUSTOMER: '/products/vacant-cot-alerts/buy',
    VACANT_COT_ALERTS_FILE_GET: '/products/vacant-cot-alerts/files',
    VACANT_COT_ALERTS_FILE_UPLOAD: '/products/vacant-cot-alerts/files',
    VACANT_COT_ALERTS_WORKFLOW_USERS: '/products/vacant-cot-alerts/workflow/users',
    VACANT_COT_ALERTS_WF_ITEMS: '/products/vacant-cot-alerts/workflow',
    VACANT_COT_ALERTS_WF_COUNTS: '/products/vacant-cot-alerts/workflow-counts',
    VACANT_COT_ALERTS_EXCLUDE_CUSTOMER: '/products/vacant-cot-alerts/exclude',
    VACANT_COT_ALERTS_DATA_FILTERS: '/products/vacant-cot-alerts/data-filters',
    VACANT_COT_ALERTS_GROUPINGS: '/products/vacant-cot-alerts/groupings',
    VACANT_COT_ALERTS_UPDATE_STATUS: '/products/vacant-cot-alerts/updateStatus',
    VACANT_COT_ALERTS_UPDATE_ADC_GROUP: '/products/vacant-cot-alerts/updateADCGroup',
    VACANT_COT_ALERTS_UPDATE_COT_DATE: '/products/vacant-cot-alerts/updateCotDate',
    VACANT_COT_ALERTS_CONFIRMATION: '/products/vacant-cot-alerts/confirm',
    VACANT_COT_ALERTS_ABP_BY_POSTCODE: '/products/vacant-cot-alerts/abp/postcode',

    VACANT_COT_ALERTS_UNALLOCATE_GET: '/products/vacant-cot-alerts/unallocate',
    VACANT_COT_ALERTS_UNALLOCATE_POST: '/products/vacant-cot-alerts/unallocate',

    VACANT_COT_ALERTS_DASHBOARD_MONTH_AND_YEAR: '/products/vacant-cot-alerts/dashboard/monthAndYear',
    VACANT_COT_ALERTS_DASHBOARD_MOVEINS_PERFORMED: '/products/vacant-cot-alerts/dashboard/moveinsPerformed',
    VACANT_COT_ALERTS_DASHBOARD_MOVEINS_TEAM_PERFORMED: '/products/vacant-cot-alerts/dashboard/teamPerformance',

    VACANT_COT_ALERTS_DASHBOARD_WORKFLOW: '/products/vacant-cot-alerts/dashboard/workflow',
    VACANT_COT_ALERTS_DASHBOARD_PERFORMANCE: '/products/vacant-cot-alerts/dashboard/performance',
    VACANT_COT_ALERTS_DASHBOARD_CONFIDENCE: '/products/vacant-cot-alerts/dashboard/confidence',
    VACANT_COT_ALERTS_DASHBOARD_REFRESH: '/products/vacant-cot-alerts/dashboard/refresh',

    VACANT_COT_ALERTS_DASHBOARD_WHOLESALER: '/products/vacant-cot-alerts/dashboard/wholesalers',
    VACANT_COT_ALERTS_DASHBOARD_ADC: '/products/vacant-cot-alerts/dashboard/adc-groups',

    VACANT_COT_ALERTS_SUBMIT_NOTES:  '/products/vacant-cot-alerts/submit-notes',
    VACANT_COT_ALERTS_ISSUE_TO_USER:  '/products/vacant-cot-alerts/issue-to-user',
    VACANT_COT_ALERTS_UPDATE_ASSESSMENT:  '/products/vacant-cot-alerts/update-assessment',

    LONG_TERM_VACANT_GET_CUSTOMER: '/products/long-term-vacant/search',
    LONG_TERM_VACANT_DATES: '/products/long-term-vacant/dates',
    LONG_TERM_VACANT_DATA: '/products/long-term-vacant',
    LONG_TERM_VACANT_SUMMARY_BULK: '/products/long-term-vacant/bulk',
    LONG_TERM_VACANT_BUY_CUSTOMER: '/products/long-term-vacant/buy',
    LONG_TERM_VACANT_FILES: '/products/long-term-vacant/files',
    LONG_TERM_VACANT_WF_USERS: '/products/long-term-vacant/workflow/users',
    LONG_TERM_VACANT_WORKFLOW: '/products/long-term-vacant/workflow',
    LONG_TERM_VACANT_EXCLUDE_CUSTOMER: '/products/long-term-vacant/exclude',
    LONG_TERM_VACANT_FILTERS: '/products/long-term-vacant/data-filters',
    LONG_TERM_VACANT_GROUPINGS: '/products/long-term-vacant/groupings',
    LONG_TERM_VACANT_UPDATE_STATUS: '/products/long-term-vacant/updateStatus',
    LONG_TERM_VACANT_CONFIRMATION: '/products/long-term-vacant/confirm',
    LONG_TERM_VACANT_ABP_BY_POSTCODE: '/products/long-term-vacant/abp/postcode',

    LONG_TERM_VACANT_UNALLOCATE_GET: '/products/long-term-vacant/unallocate',
    LONG_TERM_VACANT_UNALLOCATE_POST: '/products/long-term-vacant/unallocate',

    LONG_TERM_VACANT_DASHBOARD_MONTH_AND_YEAR: '/products/long-term-vacant/dashboard/monthAndYear',
    LONG_TERM_VACANT_DASHBOARD_MOVEINS_PERFORMED: '/products/long-term-vacant/dashboard/moveinsPerformed',
    LONG_TERM_VACANT_DASHBOARD_MOVEINS_TEAM_PERFORMED: '/products/long-term-vacant/dashboard/teamPerformance',

    LONG_TERM_VACANT_DASHBOARD_WORKFLOW: '/products/long-term-vacant/dashboard/workflow',
    LONG_TERM_VACANT_DASHBOARD_PERFORMANCE: '/products/long-term-vacant/dashboard/performance',
    LONG_TERM_VACANT_DASHBOARD_CONFIDENCE: '/products/long-term-vacant/dashboard/confidence',
    LONG_TERM_VACANT_DASHBOARD_REFRESH: '/products/long-term-vacant/dashboard/refresh',

    LONG_TERM_VACANT_DASHBOARD_WHOLESALER: '/products/long-term-vacant/dashboard/wholesalers',

    LONG_TERM_VACANT_SUBMIT_NOTES:  '/products/long-term-vacant/submit-notes',
    LONG_TERM_VACANT_ISSUE_TO_USER:  '/products/long-term-vacant/issue-to-user',
    LONG_TERM_VACANT_UPDATE_ASSESSMENT:  '/products/long-term-vacant/update-assessment',
    //
    LONG_TERM_VACANT_REPORT: '/products/long-term-vacant/report',

    // Summary
    BUSINESS_ADDRESS_ALERTS_SEARCH_BY_SPID: '/products/business-address-alerts/search',
    BUSINESS_ADDRESS_ALERTS_GET_ADDRESSES: '/products/business-address-alerts/addresses',
    BUSINESS_ADDRESS_ALERTS_GET_VOAS: '/products/business-address-alerts/voas',
    BUSINESS_ADDRESS_ALERTS_GET_SAA: '/products/business-address-alerts/saa',
    BUSINESS_ADDRESS_ALERTS_GET_CT: '/products/business-address-alerts/ct',
    BUSINESS_ADDRESS_ALERTS_MDS_SPID: '/products/business-address-alerts/mds-spid',
    BUSINESS_ADDRESS_ALERTS_MDS_METER: '/products/business-address-alerts/mds-meter',
    BUSINESS_ADDRESS_ALERTS_GET_VO_CT_COMBINED: '/products/business-address-alerts/voas-ct',
    BUSINESS_ADDRESS_ALERTS_LINKED_REFERENCES: '/products/business-address-alerts/linked-references',
    BUSINESS_ADDRESS_ALERTS_GET_METER: '/products/business-address-alerts/meter',

    // Generics
    BUSINESS_ADDRESS_ALERTS_GROUPINGS: '/products/business-address-alerts/groupings',
    BUSINESS_ADDRESS_ALERTS_FILTERS: '/products/business-address-alerts/filters',
    BUSINESS_ADDRESS_ALERTS_DATA: '/products/business-address-alerts/data',
    BUSINESS_ADDRESS_ALERTS_DATES: '/products/business-address-alerts/dates',
    BUSINESS_ADDRESS_ALERTS_FILES: '/products/business-address-alerts/files',
    // Workflow
    BUSINESS_ADDRESS_ALERTS_PURCHASE: '/products/business-address-alerts/buy',
    BUSINESS_ADDRESS_ALERTS_EXCLUDE: '/products/business-address-alerts/exclude',
    BUSINESS_ADDRESS_ALERTS_WF_USERS: '/products/business-address-alerts/workflow/users',
    BUSINESS_ADDRESS_ALERTS_WF_ITEMS: '/products/business-address-alerts/workflow',
    BUSINESS_ADDRESS_ALERTS_WF_COUNTTS: '/products/business-address-alerts/workflow-counts',
    // Bulk
    BUSINESS_ADDRESS_ALERTS_BULK_BASE: '/products/business-address-alerts/bulk',
    BUSINESS_ADDRESS_ALERTS_UNALLOCATE: '/products/business-address-alerts/unallocate',
    //
    BUSINESS_ADDRESS_ALERTS_SELECT_MATCH: '/products/business-address-alerts/select-match',
    BUSINESS_ADDRESS_ALERTS_CLEAR_MATCH: '/products/business-address-alerts/clear-match',
    BUSINESS_ADDRESS_ALERTS_UPDATE_OUTCOMES: '/products/business-address-alerts/update-outcomes',
    BUSINESS_ADDRESS_ALERTS_SUBMIT_NOTES: '/products/business-address-alerts/submit-notes',
    BUSINESS_ADDRESS_ALERTS_VERIFY_ASSURANCE: '/products/business-address-alerts/verify-assurance',
    BUSINESS_ADDRESS_ALERTS_VERIFY_ASSURANCE_UPDATES: '/products/business-address-alerts/verify-assurance-updates',

    // Summary
    MOSL_DQA_SEARCH_BY_SPID: '/products/mosl-dqa/search',
    MOSL_DQA_CMOS_LIVE: '/products/mosl-dqa/cmos-live',
    MOSL_DQA_GET_ADDRESSES: '/products/mosl-dqa/addresses',
    MOSL_DQA_GET_VOAS: '/products/mosl-dqa/voas',
    MOSL_DQA_GET_SAA: '/products/mosl-dqa/saa',
    MOSL_DQA_GET_CT: '/products/mosl-dqa/ct',
    MOSL_DQA_MDS_SPID: '/products/mosl-dqa/mds-spid',
    MOSL_DQA_MDS_METER: '/products/mosl-dqa/mds-meter',
    MOSL_DQA_GET_VO_CT_COMBINED: '/products/mosl-dqa/voas-ct',
    MOSL_DQA_LINKED_REFERENCES: '/products/mosl-dqa/linked-references',
    MOSL_DQA_GET_METER: '/products/mosl-dqa/meter',

    // Generics
    MOSL_DQA_GROUPINGS: '/products/mosl-dqa/groupings',
    MOSL_DQA_FILTERS: '/products/mosl-dqa/filters',
    MOSL_DQA_DATA: '/products/mosl-dqa/data',
    MOSL_DQA_DATES: '/products/mosl-dqa/dates',
    MOSL_DQA_FILES: '/products/mosl-dqa/files',
    // Workflow
    MOSL_DQA_PURCHASE: '/products/mosl-dqa/buy',
    MOSL_DQA_EXCLUDE: '/products/mosl-dqa/exclude',
    // Bulk
    MOSL_DQA_BULK_BASE: '/products/mosl-dqa/bulk',
    //
    MOSL_DQA_SELECT_MATCH: '/products/mosl-dqa/select-match',
    MOSL_DQA_CLEAR_MATCH: '/products/mosl-dqa/clear-match',
    MOSL_DQA_UPDATE_OUTCOMES: '/products/mosl-dqa/update-outcomes',
    MOSL_DQA_SUBMIT_NOTES: '/products/mosl-dqa/submit-notes',
    MOSL_DQA_VERIFY_ASSURANCE: '/products/mosl-dqa/verify-assurance',
    MOSL_DQA_VERIFY_ASSURANCE_UPDATES: '/products/mosl-dqa/verify-assurance-updates',

    // Summary
    PORTFOLIO_SUMMARY_SEARCH_BY_SPID: '/products/portfolio-summary/search',
    PORTFOLIO_SUMMARY_POSTCODE_SEARCH: '/products/portfolio-summary/postcode-search',
    PORTFOLIO_SUMMARY_MDS_UPLOAD: '/products/portfolio-summary/mds-upload',
    PORTFOLIO_SUMMARY_BATCH_SPID_UPLOAD: '/products/portfolio-summary/batch-spid-upload',
    PORTFOLIO_SUMMARY_GET_ADDRESSES: '/products/portfolio-summary/addresses',
    PORTFOLIO_SUMMARY_GET_VOAS: '/products/portfolio-summary/voas',
    PORTFOLIO_SUMMARY_GET_SAA: '/products/portfolio-summary/saa',
    PORTFOLIO_SUMMARY_GET_CT: '/products/portfolio-summary/ct',
    PORTFOLIO_SUMMARY_MDS_SPID: '/products/portfolio-summary/mds-spid',
    PORTFOLIO_SUMMARY_MDS_METER: '/products/portfolio-summary/mds-meter',
    PORTFOLIO_SUMMARY_GET_VO_CT_COMBINED: '/products/portfolio-summary/voas-ct',
    PORTFOLIO_SUMMARY_LINKED_REFERENCES: '/products/portfolio-summary/linked-references',
    PORTFOLIO_SUMMARY_GET_METER: '/products/portfolio-summary/meter',
    PORTFOLIO_SUMMARY_VOA_HISTORY: '/products/portfolio-summary/voa-history',

    // Generics
    PORTFOLIO_SUMMARY_GROUPINGS: '/products/portfolio-summary/groupings',
    PORTFOLIO_SUMMARY_FILTERS: '/products/portfolio-summary/filters',
    PORTFOLIO_SUMMARY_DATA: '/products/portfolio-summary/data',
    PORTFOLIO_SUMMARY_DATES: '/products/portfolio-summary/dates',
    PORTFOLIO_SUMMARY_FILES: '/products/portfolio-summary/files',
    // Workflow
    PORTFOLIO_SUMMARY_PURCHASE: '/products/portfolio-summary/buy',
    PORTFOLIO_SUMMARY_EXCLUDE: '/products/portfolio-summary/exclude',
    PORTFOLIO_SUMMARY_WF_USERS: '/products/portfolio-summary/workflow/users',
    PORTFOLIO_SUMMARY_WF_ITEMS: '/products/portfolio-summary/workflow',
    // Bulk
    PORTFOLIO_SUMMARY_BULK_BASE: '/products/portfolio-summary/bulk',
    PORTFOLIO_SUMMARY_UNALLOCATE: '/products/portfolio-summary/unallocate',
    //
    PORTFOLIO_SUMMARY_SELECT_MATCH: '/products/portfolio-summary/select-match',
    PORTFOLIO_SUMMARY_CLEAR_MATCH: '/products/portfolio-summary/clear-match',
    PORTFOLIO_SUMMARY_UPDATE_OUTCOMES: '/products/portfolio-summary/update-outcomes',
    PORTFOLIO_SUMMARY_SUBMIT_NOTES: '/products/portfolio-summary/submit-notes',
    PORTFOLIO_SUMMARY_VERIFY_ASSURANCE: '/products/portfolio-summary/verify-assurance',
    PORTFOLIO_SUMMARY_VERIFY_ASSURANCE_UPDATES: '/products/portfolio-summary/verify-assurance-updates',

    // Generics
    ADDRESS_ASSESSMENT_SEARCH_BY_SPID: '/products/address-assessment/search',
    ADDRESS_ASSESSMENT_GET_ADDRESSES: '/products/address-assessment/addresses',
    ADDRESS_ASSESSMENT_GET_VOAS: '/products/address-assessment/voas',
    ADDRESS_ASSESSMENT_GET_SAA: '/products/address-assessment/saa',
    ADDRESS_ASSESSMENT_GET_CT: '/products/address-assessment/ct',
    ADDRESS_ASSESSMENT_MDS_SPID: '/products/address-assessment/mds-spid',
    ADDRESS_ASSESSMENT_MDS_METER: '/products/address-assessment/mds-meter',
    ADDRESS_ASSESSMENT_GET_VO_CT_COMBINED: '/products/address-assessment/voas-ct',
    ADDRESS_ASSESSMENT_LINKED_REFERENCES: '/products/address-assessment/linked-references',
    ADDRESS_ASSESSMENT_GET_METER: '/products/address-assessment/meter',
    ADDRESS_ASSESSMENT_GROUPINGS: '/products/address-assessment/groupings',
    ADDRESS_ASSESSMENT_FILTERS: '/products/address-assessment/filters',
    ADDRESS_ASSESSMENT_DATA: '/products/address-assessment/data',
    ADDRESS_ASSESSMENT_DATES: '/products/address-assessment/dates',
    // Bulk
    ADDRESS_ASSESSMENT_BULK_BASE: '/products/address-assessment/bulk',
    ADDRESS_ASSESSMENT_WF_USERS: '/products/address-assessment/workflow/users',
    //
    ADDRESS_ASSESSMENT_SELECT_MATCH: '/products/address-assessment/select-match',
    ADDRESS_ASSESSMENT_CLEAR_MATCH: '/products/address-assessment/clear-match',
    ADDRESS_ASSESSMENT_UPDATE_OUTCOMES: '/products/address-assessment/update-outcomes',
    ADDRESS_ASSESSMENT_SUBMIT_NOTES: '/products/address-assessment/submit-notes',
    ADDRESS_ASSESSMENT_VERIFY_ASSURANCE: '/products/address-assessment/verify-assurance',
    ADDRESS_ASSESSMENT_VERIFY_ASSURANCE_UPDATES: '/products/address-assessment/verify-assurance-updates',

    // Summary
    INVALID_POSTCODE_STREET_SEARCH_BY_SPID: '/products/invalid-postcode-street/search',
    INVALID_POSTCODE_STREET_GET_ADDRESSES: '/products/invalid-postcode-street/addresses',
    INVALID_POSTCODE_STREET_GET_VOAS: '/products/invalid-postcode-street/voas',
    INVALID_POSTCODE_STREET_GET_SAA: '/products/invalid-postcode-street/saa',
    INVALID_POSTCODE_STREET_GET_CT: '/products/invalid-postcode-street/ct',
    INVALID_POSTCODE_STREET_MDS_SPID: '/products/invalid-postcode-street/mds-spid',
    INVALID_POSTCODE_STREET_MDS_METER: '/products/invalid-postcode-street/mds-meter',
    INVALID_POSTCODE_STREET_GET_VO_CT_COMBINED: '/products/invalid-postcode-street/voas-ct',
    INVALID_POSTCODE_STREET_LINKED_REFERENCES: '/products/invalid-postcode-street/linked-references',
    INVALID_POSTCODE_STREET_GET_METER: '/products/invalid-postcode-street/meter',
    // Generics
    INVALID_POSTCODE_STREET_GROUPINGS: '/products/invalid-postcode-street/groupings',
    INVALID_POSTCODE_STREET_FILTERS: '/products/invalid-postcode-street/filters',
    INVALID_POSTCODE_STREET_DATA: '/products/invalid-postcode-street/data',
    INVALID_POSTCODE_STREET_DATES: '/products/invalid-postcode-street/dates',
    INVALID_POSTCODE_STREET_FILES: '/products/invalid-postcode-street/files',
    // Workflow
    INVALID_POSTCODE_STREET_PURCHASE: '/products/invalid-postcode-street/buy',
    INVALID_POSTCODE_STREET_EXCLUDE: '/products/invalid-postcode-street/exclude',
    INVALID_POSTCODE_STREET_WF_USERS: '/products/invalid-postcode-street/workflow/users',
    INVALID_POSTCODE_STREET_WF_ITEMS: '/products/invalid-postcode-street/workflow',
    INVALID_POSTCODE_STREET_WF_COUNTTS: '/products/invalid-postcode-street/workflow-counts',
    // Bulk
    INVALID_POSTCODE_STREET_BULK_BASE: '/products/invalid-postcode-street/bulk',
    INVALID_POSTCODE_STREET_UNALLOCATE: '/products/invalid-postcode-street/unallocate',
    //
    INVALID_POSTCODE_STREET_SELECT_MATCH: '/products/invalid-postcode-street/select-match',
    INVALID_POSTCODE_STREET_CLEAR_MATCH: '/products/invalid-postcode-street/clear-match',
    INVALID_POSTCODE_STREET_UPDATE_OUTCOMES: '/products/invalid-postcode-street/update-outcomes',
    INVALID_POSTCODE_STREET_SUBMIT_NOTES: '/products/invalid-postcode-street/submit-notes',
    INVALID_POSTCODE_STREET_VERIFY_ASSURANCE: '/products/invalid-postcode-street/verify-assurance',
    INVALID_POSTCODE_STREET_VERIFY_ASSURANCE_UPDATES: '/products/invalid-postcode-street/verify-assurance-updates',
    //
    INVALID_POSTCODE_STREET_REPORT: '/products/invalid-postcode-street/report',

    // Summary
    AUTOMATED_ADDRESS_CLEANSE_SEARCH_BY_SPID: '/products/automated-address-cleanse/search',
    AUTOMATED_ADDRESS_CLEANSE_GET_ADDRESSES: '/products/automated-address-cleanse/addresses',
    AUTOMATED_ADDRESS_CLEANSE_GET_VOAS: '/products/automated-address-cleanse/voas',
    AUTOMATED_ADDRESS_CLEANSE_GET_SAA: '/products/automated-address-cleanse/saa',
    AUTOMATED_ADDRESS_CLEANSE_GET_CT: '/products/automated-address-cleanse/ct',
    AUTOMATED_ADDRESS_CLEANSE_MDS_SPID: '/products/automated-address-cleanse/mds-spid',
    AUTOMATED_ADDRESS_CLEANSE_MDS_METER: '/products/automated-address-cleanse/mds-meter',
    AUTOMATED_ADDRESS_CLEANSE_GET_VO_CT_COMBINED: '/products/automated-address-cleanse/voas-ct',
    AUTOMATED_ADDRESS_CLEANSE_LINKED_REFERENCES: '/products/automated-address-cleanse/linked-references',
    AUTOMATED_ADDRESS_CLEANSE_GET_METER: '/products/automated-address-cleanse/meter',

    // Generics
    AUTOMATED_ADDRESS_CLEANSE_GROUPINGS: '/products/automated-address-cleanse/groupings',
    AUTOMATED_ADDRESS_CLEANSE_FILTERS: '/products/automated-address-cleanse/filters',
    AUTOMATED_ADDRESS_CLEANSE_DATA: '/products/automated-address-cleanse/data',
    AUTOMATED_ADDRESS_CLEANSE_DATES: '/products/automated-address-cleanse/dates',
    AUTOMATED_ADDRESS_CLEANSE_FILES: '/products/automated-address-cleanse/files',
    // Workflow
    AUTOMATED_ADDRESS_CLEANSE_PURCHASE: '/products/automated-address-cleanse/buy',
    AUTOMATED_ADDRESS_CLEANSE_EXCLUDE: '/products/automated-address-cleanse/exclude',
    AUTOMATED_ADDRESS_CLEANSE_WF_USERS: '/products/automated-address-cleanse/workflow/users',
    AUTOMATED_ADDRESS_CLEANSE_WF_ITEMS: '/products/automated-address-cleanse/workflow',
    AUTOMATED_ADDRESS_CLEANSE_WF_COUNTTS: '/products/automated-address-cleanse/workflow-counts',
    // Bulk
    AUTOMATED_ADDRESS_CLEANSE_BULK_BASE: '/products/automated-address-cleanse/bulk',
    AUTOMATED_ADDRESS_CLEANSE_UNALLOCATE: '/products/automated-address-cleanse/unallocate',
    //
    AUTOMATED_ADDRESS_CLEANSE_SELECT_MATCH: '/products/automated-address-cleanse/select-match',
    AUTOMATED_ADDRESS_CLEANSE_CLEAR_MATCH: '/products/automated-address-cleanse/clear-match',
    AUTOMATED_ADDRESS_CLEANSE_UPDATE_OUTCOMES: '/products/automated-address-cleanse/update-outcomes',
    AUTOMATED_ADDRESS_CLEANSE_SUBMIT_NOTES: '/products/automated-address-cleanse/submit-notes',
    AUTOMATED_ADDRESS_CLEANSE_VERIFY_ASSURANCE: '/products/automated-address-cleanse/verify-assurance',
    AUTOMATED_ADDRESS_CLEANSE_VERIFY_ASSURANCE_UPDATES: '/products/automated-address-cleanse/verify-assurance-updates',
    //
    AUTOMATED_ADDRESS_CLEANSE_REPORT: '/products/automated-address-cleanse/report',

    // Summary
    MOSL_ELIGIBILITY_SEARCH_BY_SPID: '/products/mosl-eligibility/search',
    MOSL_ELIGIBILITY_GET_ADDRESSES: '/products/mosl-eligibility/addresses',
    MOSL_ELIGIBILITY_GET_VOAS: '/products/mosl-eligibility/voas',
    MOSL_ELIGIBILITY_GET_SAA: '/products/mosl-eligibility/saa',
    MOSL_ELIGIBILITY_GET_CT: '/products/mosl-eligibility/ct',
    // Generics
    MOSL_ELIGIBILITY_GROUPINGS: '/products/mosl-eligibility/groupings',
    MOSL_ELIGIBILITY_FILTERS: '/products/mosl-eligibility/filters',
    MOSL_ELIGIBILITY_DATA: '/products/mosl-eligibility/data',
    MOSL_ELIGIBILITY_DATES: '/products/mosl-eligibility/dates',
    MOSL_ELIGIBILITY_FILES: '/products/mosl-eligibility/files',
    // Report
    MOSL_ELIGIBILITY_REPORT_GROUPINGS: '/products/mosl-eligibility/report/groupings',
    MOSL_ELIGIBILITY_REPORT_FILTERS: '/products/mosl-eligibility/report/filters',
    MOSL_ELIGIBILITY_REPORT_DATA: '/products/mosl-eligibility/report/data',
    MOSL_ELIGIBILITY_REPORT_DATES: '/products/mosl-eligibility/report/dates',
    // Workflow
    MOSL_ELIGIBILITY_PURCHASE: '/products/mosl-eligibility/buy',
    MOSL_ELIGIBILITY_EXCLUDE: '/products/mosl-eligibility/exclude',
    MOSL_ELIGIBILITY_WF_USERS: '/products/mosl-eligibility/workflow/users',
    MOSL_ELIGIBILITY_WF_ITEMS: '/products/mosl-eligibility/workflow',
    MOSL_ELIGIBILITY_WF_COUNTTS: '/products/mosl-eligibility/workflow-counts',
    // Bulk
    MOSL_ELIGIBILITY_BULK_BASE: '/products/mosl-eligibility/bulk',
    MOSL_ELIGIBILITY_UNALLOCATE: '/products/mosl-eligibility/unallocate',
    //
    MOSL_ELIGIBILITY_SELECT_MATCH: '/products/mosl-eligibility/select-match',
    MOSL_ELIGIBILITY_CLEAR_MATCH: '/products/mosl-eligibility/clear-match',
    MOSL_ELIGIBILITY_UPDATE_OUTCOMES: '/products/mosl-eligibility/update-outcomes',
    MOSL_ELIGIBILITY_SUBMIT_NOTES: '/products/mosl-eligibility/submit-notes',
    MOSL_ELIGIBILITY_VERIFY_ASSURANCE: '/products/mosl-eligibility/verify-assurance',
    MOSL_ELIGIBILITY_VERIFY_ASSURANCE_UPDATES: '/products/mosl-eligibility/verify-assurance-updates',

    // Summary
    UNDELIVERABLE_SEARCH_BY_SPID: '/products/undeliverable/search',
    UNDELIVERABLE_GET_ADDRESSES: '/products/undeliverable/addresses',
    UNDELIVERABLE_GET_VOAS: '/products/undeliverable/voas',
    UNDELIVERABLE_GET_SAA: '/products/undeliverable/saa',
    UNDELIVERABLE_GET_CT: '/products/undeliverable/ct',
    UNDELIVERABLE_MDS_SPID: '/products/undeliverable/mds-spid',
    UNDELIVERABLE_MDS_METER: '/products/undeliverable/mds-meter',
    UNDELIVERABLE_GET_VO_CT_COMBINED: '/products/undeliverable/voas-ct',
    UNDELIVERABLE_LINKED_REFERENCES: '/products/undeliverable/linked-references',
    UNDELIVERABLE_GET_METER: '/products/undeliverable/meter',

    // Generics
    UNDELIVERABLE_GROUPINGS: '/products/undeliverable/groupings',
    UNDELIVERABLE_FILTERS: '/products/undeliverable/filters',
    UNDELIVERABLE_DATA: '/products/undeliverable/data',
    UNDELIVERABLE_DATES: '/products/undeliverable/dates',
    UNDELIVERABLE_FILES: '/products/undeliverable/files',
    // Report
    UNDELIVERABLE_REPORT_GROUPINGS: '/products/undeliverable/report/groupings',
    UNDELIVERABLE_REPORT_FILTERS: '/products/undeliverable/report/filters',
    UNDELIVERABLE_REPORT_DATA: '/products/undeliverable/report/data',
    UNDELIVERABLE_REPORT_DATES: '/products/undeliverable/report/dates',
    // Workflow
    UNDELIVERABLE_PURCHASE: '/products/undeliverable/buy',
    UNDELIVERABLE_EXCLUDE: '/products/undeliverable/exclude',
    UNDELIVERABLE_WF_USERS: '/products/undeliverable/workflow/users',
    UNDELIVERABLE_WF_ITEMS: '/products/undeliverable/workflow',
    UNDELIVERABLE_WF_COUNTTS: '/products/undeliverable/workflow-counts',
    // Bulk
    UNDELIVERABLE_BULK_BASE: '/products/undeliverable/bulk',
    UNDELIVERABLE_UNALLOCATE: '/products/undeliverable/unallocate',
    //
    UNDELIVERABLE_SELECT_MATCH: '/products/undeliverable/select-match',
    UNDELIVERABLE_CLEAR_MATCH: '/products/undeliverable/clear-match',
    UNDELIVERABLE_UPDATE_OUTCOMES: '/products/undeliverable/update-outcomes',
    UNDELIVERABLE_SUBMIT_NOTES: '/products/undeliverable/submit-notes',
    UNDELIVERABLE_VERIFY_ASSURANCE: '/products/undeliverable/verify-assurance',
    UNDELIVERABLE_VERIFY_ASSURANCE_UPDATES: '/products/undeliverable/verify-assurance-updates',
    //
    UNDELIVERABLE_REPORT: '/products/undeliverable/report',

    // Summary
    INVALID_UPRN_VOA_SEARCH_BY_SPID: '/products/invalid-uprn-voa/search',
    INVALID_UPRN_VOA_GET_ADDRESSES: '/products/invalid-uprn-voa/addresses',
    INVALID_UPRN_VOA_GET_VOAS: '/products/invalid-uprn-voa/voas',
    INVALID_UPRN_VOA_GET_SAA: '/products/invalid-uprn-voa/saa',
    INVALID_UPRN_VOA_GET_CT: '/products/invalid-uprn-voa/ct',
    INVALID_UPRN_VOA_MDS_SPID: '/products/invalid-uprn-voa/mds-spid',
    INVALID_UPRN_VOA_MDS_METER: '/products/invalid-uprn-voa/mds-meter',
    INVALID_UPRN_VOA_GET_VO_CT_COMBINED: '/products/invalid-uprn-voa/voas-ct',
    INVALID_UPRN_VOA_LINKED_REFERENCES: '/products/invalid-uprn-voa/linked-references',
    INVALID_UPRN_VOA_GET_METER: '/products/invalid-uprn-voa/meter',

    // Generics
    INVALID_UPRN_VOA_GROUPINGS: '/products/invalid-uprn-voa/groupings',
    INVALID_UPRN_VOA_FILTERS: '/products/invalid-uprn-voa/filters',
    INVALID_UPRN_VOA_DATA: '/products/invalid-uprn-voa/data',
    INVALID_UPRN_VOA_DATES: '/products/invalid-uprn-voa/dates',
    INVALID_UPRN_VOA_FILES: '/products/invalid-uprn-voa/files',
    // Report
    INVALID_UPRN_VOA_REPORT_GROUPINGS: '/products/invalid-uprn-voa/report/groupings',
    INVALID_UPRN_VOA_REPORT_FILTERS: '/products/invalid-uprn-voa/report/filters',
    INVALID_UPRN_VOA_REPORT_DATA: '/products/invalid-uprn-voa/report/data',
    INVALID_UPRN_VOA_REPORT_DATES: '/products/invalid-uprn-voa/report/dates',
    // Workflow
    INVALID_UPRN_VOA_PURCHASE: '/products/invalid-uprn-voa/buy',
    INVALID_UPRN_VOA_EXCLUDE: '/products/invalid-uprn-voa/exclude',
    INVALID_UPRN_VOA_WF_USERS: '/products/invalid-uprn-voa/workflow/users',
    INVALID_UPRN_VOA_WF_ITEMS: '/products/invalid-uprn-voa/workflow',
    INVALID_UPRN_VOA_WF_COUNTTS: '/products/invalid-uprn-voa/workflow-counts',
    // Bulk
    INVALID_UPRN_VOA_BULK_BASE: '/products/invalid-uprn-voa/bulk',
    INVALID_UPRN_VOA_UNALLOCATE: '/products/invalid-uprn-voa/unallocate',
    //
    INVALID_UPRN_VOA_SELECT_MATCH: '/products/invalid-uprn-voa/select-match',
    INVALID_UPRN_VOA_CLEAR_MATCH: '/products/invalid-uprn-voa/clear-match',
    INVALID_UPRN_VOA_UPDATE_OUTCOMES: '/products/invalid-uprn-voa/update-outcomes',
    INVALID_UPRN_VOA_SUBMIT_NOTES: '/products/invalid-uprn-voa/submit-notes',
    INVALID_UPRN_VOA_VERIFY_ASSURANCE: '/products/invalid-uprn-voa/verify-assurance',
    INVALID_UPRN_VOA_VERIFY_ASSURANCE_UPDATES: '/products/invalid-uprn-voa/verify-assurance-updates',
    //
    INVALID_UPRN_VOA_REPORT: '/products/invalid-uprn-voa/report',

    // Summary
    INVALID_UPRN_VOA_CMOS_SEARCH_BY_SPID: '/products/invalid-uprn-voa-cmos/search',
    INVALID_UPRN_VOA_CMOS_GET_ADDRESSES: '/products/invalid-uprn-voa-cmos/addresses',
    INVALID_UPRN_VOA_CMOS_GET_VOAS: '/products/invalid-uprn-voa-cmos/voas',
    INVALID_UPRN_VOA_CMOS_GET_SAA: '/products/invalid-uprn-voa-cmos/saa',
    INVALID_UPRN_VOA_CMOS_GET_CT: '/products/invalid-uprn-voa-cmos/ct',
    INVALID_UPRN_VOA_CMOS_MDS_SPID: '/products/invalid-uprn-voa-cmos/mds-spid',
    INVALID_UPRN_VOA_CMOS_MDS_METER: '/products/invalid-uprn-voa-cmos/mds-meter',
    INVALID_UPRN_VOA_CMOS_GET_VO_CT_COMBINED: '/products/invalid-uprn-voa-cmos/voas-ct',
    INVALID_UPRN_VOA_CMOS_LINKED_REFERENCES: '/products/invalid-uprn-voa-cmos/linked-references',
    INVALID_UPRN_VOA_CMOS_GET_METER: '/products/invalid-uprn-voa-cmos/meter',

    // Generics
    INVALID_UPRN_VOA_CMOS_GROUPINGS: '/products/invalid-uprn-voa-cmos/groupings',
    INVALID_UPRN_VOA_CMOS_FILTERS: '/products/invalid-uprn-voa-cmos/filters',
    INVALID_UPRN_VOA_CMOS_DATA: '/products/invalid-uprn-voa-cmos/data',
    INVALID_UPRN_VOA_CMOS_DATES: '/products/invalid-uprn-voa-cmos/dates',
    INVALID_UPRN_VOA_CMOS_FILES: '/products/invalid-uprn-voa-cmos/files',
    // Report
    INVALID_UPRN_VOA_CMOS_REPORT_GROUPINGS: '/products/invalid-uprn-voa-cmos/report/groupings',
    INVALID_UPRN_VOA_CMOS_REPORT_FILTERS: '/products/invalid-uprn-voa-cmos/report/filters',
    INVALID_UPRN_VOA_CMOS_REPORT_DATA: '/products/invalid-uprn-voa-cmos/report/data',
    INVALID_UPRN_VOA_CMOS_REPORT_DATES: '/products/invalid-uprn-voa-cmos/report/dates',
    // Workflow
    INVALID_UPRN_VOA_CMOS_PURCHASE: '/products/invalid-uprn-voa-cmos/buy',
    INVALID_UPRN_VOA_CMOS_EXCLUDE: '/products/invalid-uprn-voa-cmos/exclude',
    INVALID_UPRN_VOA_CMOS_WF_USERS: '/products/invalid-uprn-voa-cmos/workflow/users',
    INVALID_UPRN_VOA_CMOS_WF_ITEMS: '/products/invalid-uprn-voa-cmos/workflow',
    INVALID_UPRN_VOA_CMOS_WF_COUNTTS: '/products/invalid-uprn-voa-cmos/workflow-counts',
    // Bulk
    INVALID_UPRN_VOA_CMOS_BULK_BASE: '/products/invalid-uprn-voa-cmos/bulk',
    INVALID_UPRN_VOA_CMOS_UNALLOCATE: '/products/invalid-uprn-voa-cmos/unallocate',
    //
    INVALID_UPRN_VOA_CMOS_SELECT_MATCH: '/products/invalid-uprn-voa-cmos/select-match',
    INVALID_UPRN_VOA_CMOS_CLEAR_MATCH: '/products/invalid-uprn-voa-cmos/clear-match',
    INVALID_UPRN_VOA_CMOS_UPDATE_OUTCOMES: '/products/invalid-uprn-voa-cmos/update-outcomes',
    INVALID_UPRN_VOA_CMOS_SUBMIT_NOTES: '/products/invalid-uprn-voa-cmos/submit-notes',
    INVALID_UPRN_VOA_CMOS_VERIFY_ASSURANCE: '/products/invalid-uprn-voa-cmos/verify-assurance',
    INVALID_UPRN_VOA_CMOS_VERIFY_ASSURANCE_UPDATES: '/products/invalid-uprn-voa-cmos/verify-assurance-updates',
    //
    INVALID_UPRN_VOA_CMOS_REPORT: '/products/invalid-uprn-voa-cmos/report',

    // Summary
    METER_COORDINATION_VALIDAITON_SEARCH_BY_SPID: '/products/meter-coordinates-validation/search',
    METER_COORDINATION_VALIDAITON_SEARCH_BY_CORE_SPID: '/products/meter-coordinates-validation/search-spid',
    METER_COORDINATION_VALIDAITON_GET_PREMISES: '/products/meter-coordinates-validation/premises',
    METER_COORDINATION_VALIDAITON_GET_ADDRESSES: '/products/meter-coordinates-validation/addresses',
    METER_COORDINATION_VALIDAITON_GET_VOAS: '/products/meter-coordinates-validation/voas',
    METER_COORDINATION_VALIDAITON_GET_CMOS_UPRN: '/products/meter-coordinates-validation/cmos-uprn',
    METER_COORDINATION_VALIDAITON_GET_MATCHED_UPRN: '/products/meter-coordinates-validation/matched-uprn',
    METER_COORDINATION_VALIDAITON_GET_METER: '/products/meter-coordinates-validation/meter',
    METER_COORDINATION_VALIDAITON_GET_SAA: '/products/meter-coordinates-validation/saa',
    METER_COORDINATION_VALIDAITON_GET_CT: '/products/meter-coordinates-validation/ct',
    METER_COORDINATION_VALIDAITON_MDS_SPID: '/products/meter-coordinates-validation/mds-spid',
    METER_COORDINATION_VALIDAITON_GET_VO_CT_COMBINED: '/products/meter-coordinates-validation/voas-ct',
    METER_COORDINATION_VALIDAITON_LINKED_REFERENCES: '/products/meter-coordinates-validation/linked-references',

    // Generics
    METER_COORDINATION_VALIDAITON_GROUPINGS: '/products/meter-coordinates-validation/groupings',
    METER_COORDINATION_VALIDAITON_FILTERS: '/products/meter-coordinates-validation/filters',
    METER_COORDINATION_VALIDAITON_DATA: '/products/meter-coordinates-validation/data',
    METER_COORDINATION_VALIDAITON_DATES: '/products/meter-coordinates-validation/dates',
    METER_COORDINATION_VALIDAITON_FILES: '/products/meter-coordinates-validation/files',
    METER_COORDINATION_VALIDAITON_CDS_UPLOAD: '/products/meter-coordinates-validation/cds-upload',
    // Workflow
    METER_COORDINATION_VALIDAITON_PURCHASE: '/products/meter-coordinates-validation/buy',
    METER_COORDINATION_VALIDAITON_EXCLUDE: '/products/meter-coordinates-validation/exclude',
    METER_COORDINATION_VALIDAITON_WF_USERS: '/products/meter-coordinates-validation/workflow/users',
    METER_COORDINATION_VALIDAITON_WF_ITEMS: '/products/meter-coordinates-validation/workflow',
    METER_COORDINATION_VALIDAITON_WF_COUNTTS: '/products/meter-coordinates-validation/workflow-counts',
    // Bulk
    METER_COORDINATION_VALIDAITON_BULK_BASE: '/products/meter-coordinates-validation/bulk',
    METER_COORDINATION_VALIDAITON_UNALLOCATE: '/products/meter-coordinates-validation/unallocate',
    //
    METER_COORDINATION_VALIDAITON_SELECT_MATCH: '/products/meter-coordinates-validation/select-match',
    METER_COORDINATION_VALIDAITON_CLEAR_MATCH: '/products/meter-coordinates-validation/clear-match',
    METER_COORDINATION_VALIDAITON_UPDATE_OUTCOMES: '/products/meter-coordinates-validation/update-outcomes',
    METER_COORDINATION_VALIDAITON_SUBMIT_NOTES: '/products/meter-coordinates-validation/submit-notes',
    METER_COORDINATION_VALIDAITON_VERIFY_ASSURANCE: '/products/meter-coordinates-validation/verify-assurance',
    METER_COORDINATION_VALIDAITON_VERIFY_ASSURANCE_UPDATES: '/products/meter-coordinates-validation/verify-assurance-updates',
    //
    METER_COORDINATION_VALIDAITON_REPORT: '/products/meter-coordinates-validation/report',

        // Summary
    LONG_UNREAD_METERS_SEARCH_BY_SPID: '/products/long-unread-meters/search',
    LONG_UNREAD_METERS_SEARCH_BY_CORE_SPID: '/products/long-unread-meters/search-spid',
    LONG_UNREAD_METERS_GET_PREMISES: '/products/long-unread-meters/premises',
    LONG_UNREAD_METERS_GET_ADDRESSES: '/products/long-unread-meters/addresses',
    LONG_UNREAD_METERS_GET_VOAS: '/products/long-unread-meters/voas',
    LONG_UNREAD_METERS_GET_CMOS_UPRN: '/products/long-unread-meters/cmos-uprn',
    LONG_UNREAD_METERS_GET_MATCHED_UPRN: '/products/long-unread-meters/matched-uprn',
    LONG_UNREAD_METERS_GET_METER: '/products/long-unread-meters/meter',
    LONG_UNREAD_METERS_GET_SAA: '/products/long-unread-meters/saa',
    LONG_UNREAD_METERS_GET_CT: '/products/long-unread-meters/ct',
    LONG_UNREAD_METERS_MDS_SPID: '/products/long-unread-meters/mds-spid',
    LONG_UNREAD_METERS_GET_VO_CT_COMBINED: '/products/long-unread-meters/voas-ct',
    LONG_UNREAD_METERS_LINKED_REFERENCES: '/products/long-unread-meters/linked-references',

    // Generics
    LONG_UNREAD_METERS_GROUPINGS: '/products/long-unread-meters/groupings',
    LONG_UNREAD_METERS_FILTERS: '/products/long-unread-meters/filters',
    LONG_UNREAD_METERS_DATA: '/products/long-unread-meters/data',
    LONG_UNREAD_METERS_DATES: '/products/long-unread-meters/dates',
    LONG_UNREAD_METERS_FILES: '/products/long-unread-meters/files',
    LONG_UNREAD_METERS_CDS_UPLOAD: '/products/long-unread-meters/cds-upload',
    // Workflow
    LONG_UNREAD_METERS_PURCHASE: '/products/long-unread-meters/buy',
    LONG_UNREAD_METERS_EXCLUDE: '/products/long-unread-meters/exclude',
    LONG_UNREAD_METERS_WF_USERS: '/products/long-unread-meters/workflow/users',
    LONG_UNREAD_METERS_WF_ITEMS: '/products/long-unread-meters/workflow',
    LONG_UNREAD_METERS_WF_COUNTTS: '/products/long-unread-meters/workflow-counts',
    // Bulk
    LONG_UNREAD_METERS_BULK_BASE: '/products/long-unread-meters/bulk',
    LONG_UNREAD_METERS_UNALLOCATE: '/products/long-unread-meters/unallocate',
    //
    LONG_UNREAD_METERS_SELECT_MATCH: '/products/long-unread-meters/select-match',
    LONG_UNREAD_METERS_CLEAR_MATCH: '/products/long-unread-meters/clear-match',
    LONG_UNREAD_METERS_UPDATE_OUTCOMES: '/products/long-unread-meters/update-outcomes',
    LONG_UNREAD_METERS_SUBMIT_NOTES: '/products/long-unread-meters/submit-notes',
    LONG_UNREAD_METERS_VERIFY_ASSURANCE: '/products/long-unread-meters/verify-assurance',
    LONG_UNREAD_METERS_VERIFY_ASSURANCE_UPDATES: '/products/long-unread-meters/verify-assurance-updates',
    //
    LONG_UNREAD_METERS_REPORT: '/products/long-unread-meters/report',

    // Summary
    DATA_CLEANSE_VALIDATION_SEARCH_BY_SPID: '/products/data-cleanse-validation/search',
    DATA_CLEANSE_VALIDATION_GET_PREMISES: '/products/data-cleanse-validation/premises',
    DATA_CLEANSE_VALIDATION_GET_ADDRESSES: '/products/data-cleanse-validation/addresses',
    DATA_CLEANSE_VALIDATION_GET_VOAS: '/products/data-cleanse-validation/voas',
    DATA_CLEANSE_VALIDATION_GET_CMOS_UPRN: '/products/data-cleanse-validation/cmos-uprn',
    DATA_CLEANSE_VALIDATION_GET_MATCHED_UPRN: '/products/data-cleanse-validation/matched-uprn',
    DATA_CLEANSE_VALIDATION_GET_METER: '/products/data-cleanse-validation/meter',
    DATA_CLEANSE_VALIDATION_GET_SAA: '/products/data-cleanse-validation/saa',
    DATA_CLEANSE_VALIDATION_GET_CT: '/products/data-cleanse-validation/ct',
    DATA_CLEANSE_VALIDATION_MDS_SPID: '/products/data-cleanse-validation/mds-spid',
    DATA_CLEANSE_VALIDATION_MDS_METER: '/products/data-cleanse-validation/mds-meter',
    DATA_CLEANSE_VALIDATION_GET_VO_CT_COMBINED: '/products/data-cleanse-validation/voas-ct',
    DATA_CLEANSE_VALIDATION_LINKED_REFERENCES: '/products/data-cleanse-validation/linked-references',
    DATA_CLEANSE_VALIDATION_SUBMIT_NOTES: '/products/data-cleanse-validation/submit-notes',

    // Generics
    DATA_CLEANSE_VALIDATION_GROUPINGS: '/products/data-cleanse-validation/groupings',
    DATA_CLEANSE_VALIDATION_FILTERS: '/products/data-cleanse-validation/filters',
    DATA_CLEANSE_VALIDATION_DATA: '/products/data-cleanse-validation/data',
    DATA_CLEANSE_VALIDATION_DATES: '/products/data-cleanse-validation/dates',
    DATA_CLEANSE_VALIDATION_FILES: '/products/data-cleanse-validation/files',
    // Workflow
    DATA_CLEANSE_VALIDATION_WF_USERS: '/products/data-cleanse-validation/workflow/users',
    DATA_CLEANSE_VALIDATION_WF_ITEMS: '/products/data-cleanse-validation/workflow',
    DATA_CLEANSE_VALIDATION_ASSURANCE_ITEMS: '/products/data-cleanse-validation/assurance-items',
    DATA_CLEANSE_VALIDATION_WF_COUNTTS: '/products/data-cleanse-validation/workflow-counts',
    DATA_CLEANSE_VALIDATION_QA_USERS: '/products/data-cleanse-validation/qa/users',
    DATA_CLEANSE_VALIDATION_SELECT_MATCH: '/products/data-cleanse-validation/select-match',
    DATA_CLEANSE_VALIDATION_BULK_REJECT: '/products/data-cleanse-validation/bulk-reject',
    DATA_CLEANSE_VALIDATION_BULK_REJECT_ASSURANCE: '/products/data-cleanse-validation/bulk-reject-assurance',
    // Bulk
    DATA_CLEANSE_VALIDATION_BULK_BASE: '/products/data-cleanse-validation/bulk',
    DATA_CLEANSE_VALIDATION_VERIFY_ASSURANCE: '/products/data-cleanse-validation/verify-assurance',
    DATA_CLEANSE_VALIDATION_VERIFY_ASSURANCE_UPDATES: '/products/data-cleanse-validation/verify-assurance-updates',

    // Generics
    SMART_METER_ROLLOUT_GROUPINGS: '/products/smart-meter-rollout/groupings',
    SMART_METER_ROLLOUT_FILTERS: '/products/smart-meter-rollout/filters',
    SMART_METER_ROLLOUT_DATA: '/products/smart-meter-rollout/data',
    SMART_METER_ROLLOUT_DATES: '/products/smart-meter-rollout/dates',
    SMART_METER_ROLLOUT_FILES: '/products/smart-meter-rollout/files',
    SMART_METER_ROLLOUT_UPDATE_STATUS: '/products/smart-meter-rollout/updateStatus',
    SMART_METER_ROLLOUT_UNALLOCATE_GET: '/products/smart-meter-rollout/unallocate',
    SMART_METER_ROLLOUT_UNALLOCATE_POST: '/products/smart-meter-rollout/unallocate',
    // Workflow
    SMART_METER_ROLLOUT_BUY_CUSTOMER: '/products/smart-meter-rollout/buy',
    SMART_METER_ROLLOUT_EXCLUDE_CUSTOMER: '/products/smart-meter-rollout/exclude',
    SMART_METER_ROLLOUT_WF_USERS: '/products/smart-meter-rollout/workflow/users',
    SMART_METER_ROLLOUT_WF_ITEMS: '/products/smart-meter-rollout/workflow',
    SMART_METER_ROLLOUT_WF_COUNTS: '/products/smart-meter-rollout/workflow-counts',
    // Bulk
    SMART_METER_ROLLOUT_BULK_BASE: '/products/smart-meter-rollout/bulk',
    //
    SMART_METER_ROLLOUT_GET_CUSTOMER: '/products/smart-meter-rollout/lookup',

    SMART_METER_ROLLOUT_UPDATE_COT_DATE: '/products/smart-meter-rollout/updateCotDate',

    // Summary
    PRIORITY_CLEANSING_SEARCH_BY_SPID: '/products/priority-cleansing/search',
    PRIORITY_CLEANSING_SEARCH_BY_CORE_SPID: '/products/priority-cleansing/search-spid',
    PRIORITY_CLEANSING_GET_PREMISES: '/products/priority-cleansing/premises',
    PRIORITY_CLEANSING_GET_ADDRESSES: '/products/priority-cleansing/addresses',
    PRIORITY_CLEANSING_GET_VOAS: '/products/priority-cleansing/voas',
    PRIORITY_CLEANSING_GET_CMOS_UPRN: '/products/priority-cleansing/cmos-uprn',
    PRIORITY_CLEANSING_GET_MATCHED_UPRN: '/products/priority-cleansing/matched-uprn',
    PRIORITY_CLEANSING_GET_METER: '/products/priority-cleansing/meter',
    PRIORITY_CLEANSING_GET_SAA: '/products/priority-cleansing/saa',
    PRIORITY_CLEANSING_GET_CT: '/products/priority-cleansing/ct',
    PRIORITY_CLEANSING_MDS_SPID: '/products/priority-cleansing/mds-spid',
    PRIORITY_CLEANSING_MDS_METER: '/products/priority-cleansing/mds-meter',
    PRIORITY_CLEANSING_GET_VO_CT_COMBINED: '/products/priority-cleansing/voas-ct',
    PRIORITY_CLEANSING_LINKED_REFERENCES: '/products/priority-cleansing/linked-references',

    // Generics
    PRIORITY_CLEANSING_GROUPINGS: '/products/priority-cleansing/groupings',
    PRIORITY_CLEANSING_FILTERS: '/products/priority-cleansing/filters',
    PRIORITY_CLEANSING_DATA: '/products/priority-cleansing/data',
    PRIORITY_CLEANSING_DATES: '/products/priority-cleansing/dates',
    PRIORITY_CLEANSING_FILES: '/products/priority-cleansing/files',
    PRIORITY_CLEANSING_UPLOAD_METERS: '/products/priority-cleansing/Meters',
    PRIORITY_CLEANSING_UPLOAD_SPIDS: '/products/priority-cleansing/Spids',
    // Workflow
    PRIORITY_CLEANSING_WF_USERS: '/products/priority-cleansing/workflow/users',
    PRIORITY_CLEANSING_WF_ITEMS: '/products/priority-cleansing/workflow',
    PRIORITY_CLEANSING_WF_COUNTTS: '/products/priority-cleansing/workflow-counts',
    // Bulk
    PRIORITY_CLEANSING_BULK_BASE: '/products/priority-cleansing/bulk',
    PRIORITY_CLEANSING_BULK_SPIDS: '/products/priority-cleansing/bulk/spids',
    PRIORITY_CLEANSING_BULK_METERS: '/products/priority-cleansing/bulk/meters',
    PRIORITY_CLEANSING_UNALLOCATE_SPIDS: '/products/priority-cleansing/unallocate/spids',
    PRIORITY_CLEANSING_UNALLOCATE_METERS: '/products/priority-cleansing/unallocate/meters',
    //
    PRIORITY_CLEANSING_SUBMIT_NOTES: '/products/priority-cleansing/submit-notes',
    PRIORITY_CLEANSING_SELECT_MATCH: '/products/priority-cleansing/select-match',
    PRIORITY_CLEANSING_CLEAR_MATCH: '/products/priority-cleansing/clear-match',
    PRIORITY_CLEANSING_UPDATE_OUTCOMES: '/products/priority-cleansing/update-outcomes',
    PRIORITY_CLEANSING_VERIFY_ASSURANCE: '/products/priority-cleansing/verify-assurance',
    PRIORITY_CLEANSING_VERIFY_ASSURANCE_UPDATES: '/products/priority-cleansing/verify-assurance-updates',
    //
    PRIORITY_CLEANSING_REPORT: '/products/priority-cleansing/report',

    // Summary
    MANAGED_SERVICE_SEARCH_BY_SPID: '/products/managed-service/search',
    MANAGED_SERVICE_SEARCH_BY_CORE_SPID: '/products/managed-service/search-spid',
    MANAGED_SERVICE_GET_PREMISES: '/products/managed-service/premises',
    MANAGED_SERVICE_GET_ADDRESSES: '/products/managed-service/addresses',
    MANAGED_SERVICE_GET_VOAS: '/products/managed-service/voas',
    MANAGED_SERVICE_GET_CMOS_UPRN: '/products/managed-service/cmos-uprn',
    MANAGED_SERVICE_GET_MATCHED_UPRN: '/products/managed-service/matched-uprn',
    MANAGED_SERVICE_GET_METER: '/products/managed-service/meter',
    MANAGED_SERVICE_GET_SAA: '/products/managed-service/saa',
    MANAGED_SERVICE_GET_CT: '/products/managed-service/ct',
    MANAGED_SERVICE_MDS_SPID: '/products/managed-service/mds-spid',
    MANAGED_SERVICE_MDS_METER: '/products/managed-service/mds-meter',
    MANAGED_SERVICE_GET_VO_CT_COMBINED: '/products/managed-service/voas-ct',
    MANAGED_SERVICE_LINKED_REFERENCES: '/products/managed-service/linked-references',
    MANAGED_SERVICE_VOA_HISTORY: '/products/managed-service/voa-history',

    // Generics
    MANAGED_SERVICE_GROUPINGS: '/products/managed-service/groupings',
    MANAGED_SERVICE_FILTERS: '/products/managed-service/filters',
    MANAGED_SERVICE_DATA: '/products/managed-service/data',
    MANAGED_SERVICE_DATES: '/products/managed-service/dates',
    MANAGED_SERVICE_FILES: '/products/managed-service/files',
    MANAGED_SERVICE_UPLOAD_METERS: '/products/managed-service/Meters',
    MANAGED_SERVICE_UPLOAD_SPIDS: '/products/managed-service/Spids',
    // Workflow
    MANAGED_SERVICE_WF_USERS: '/products/managed-service/workflow/users',
    MANAGED_SERVICE_WF_ITEMS: '/products/managed-service/workflow',
    MANAGED_SERVICE_WF_COUNTTS: '/products/managed-service/workflow-counts',
    // Bulk
    MANAGED_SERVICE_BULK_BASE: '/products/managed-service/bulk',
    MANAGED_SERVICE_BULK_SPIDS: '/products/managed-service/bulk/spids',
    MANAGED_SERVICE_BULK_METERS: '/products/managed-service/bulk/meters',
    MANAGED_SERVICE_UNALLOCATE_SPIDS: '/products/managed-service/unallocate/spids',
    MANAGED_SERVICE_UNALLOCATE_METERS: '/products/managed-service/unallocate/meters',
    //
    MANAGED_SERVICE_SUBMIT_NOTES: '/products/managed-service/submit-notes',
    MANAGED_SERVICE_SELECT_MATCH: '/products/managed-service/select-match',
    MANAGED_SERVICE_CLEAR_MATCH: '/products/managed-service/clear-match',
    MANAGED_SERVICE_UPDATE_OUTCOMES: '/products/managed-service/update-outcomes',
    MANAGED_SERVICE_VERIFY_ASSURANCE: '/products/managed-service/verify-assurance',
    MANAGED_SERVICE_VERIFY_ASSURANCE_UPDATES: '/products/managed-service/verify-assurance-updates',
    //
    MANAGED_SERVICE_REPORT: '/products/managed-service/report',

    // Summary
    UPRN_CHANGES_SEARCH_BY_SPID: '/products/uprn-changes/search',
    UPRN_CHANGES_SEARCH_BY_CORE_SPID: '/products/uprn-changes/search-spid',
    UPRN_CHANGES_GET_PREMISES: '/products/uprn-changes/premises',
    UPRN_CHANGES_GET_ADDRESSES: '/products/uprn-changes/addresses',
    UPRN_CHANGES_GET_VOAS: '/products/uprn-changes/voas',
    UPRN_CHANGES_GET_CMOS_UPRN: '/products/uprn-changes/cmos-uprn',
    UPRN_CHANGES_GET_MATCHED_UPRN: '/products/uprn-changes/matched-uprn',
    UPRN_CHANGES_GET_METER: '/products/uprn-changes/meter',
    UPRN_CHANGES_GET_SAA: '/products/uprn-changes/saa',
    UPRN_CHANGES_GET_CT: '/products/uprn-changes/ct',
    UPRN_CHANGES_MDS_SPID: '/products/uprn-changes/mds-spid',
    UPRN_CHANGES_MDS_METER: '/products/uprn-changes/mds-meter',
    UPRN_CHANGES_GET_VO_CT_COMBINED: '/products/uprn-changes/voas-ct',
    UPRN_CHANGES_LINKED_REFERENCES: '/products/uprn-changes/linked-references',
    UPRN_CHANGES_VOA_HISTORY: '/products/uprn-changes/voa-history',

    // Generics
    UPRN_CHANGES_GROUPINGS: '/products/uprn-changes/groupings',
    UPRN_CHANGES_FILTERS: '/products/uprn-changes/filters',
    UPRN_CHANGES_DATA: '/products/uprn-changes/data',
    UPRN_CHANGES_DATES: '/products/uprn-changes/dates',
    UPRN_CHANGES_FILES: '/products/uprn-changes/files',
    UPRN_CHANGES_UPLOAD_METERS: '/products/uprn-changes/Meters',
    UPRN_CHANGES_UPLOAD_SPIDS: '/products/uprn-changes/Spids',
    // Workflow
    UPRN_CHANGES_WF_USERS: '/products/uprn-changes/workflow/users',
    UPRN_CHANGES_WF_ITEMS: '/products/uprn-changes/workflow',
    UPRN_CHANGES_WF_COUNTTS: '/products/uprn-changes/workflow-counts',
    // Bulk
    UPRN_CHANGES_BULK_BASE: '/products/uprn-changes/bulk',
    UPRN_CHANGES_BULK_SPIDS: '/products/uprn-changes/bulk/spids',
    UPRN_CHANGES_BULK_METERS: '/products/uprn-changes/bulk/meters',
    UPRN_CHANGES_UNALLOCATE_SPIDS: '/products/uprn-changes/unallocate/spids',
    UPRN_CHANGES_UNALLOCATE_METERS: '/products/uprn-changes/unallocate/meters',
    //
    UPRN_CHANGES_SUBMIT_NOTES: '/products/uprn-changes/submit-notes',
    UPRN_CHANGES_SELECT_MATCH: '/products/uprn-changes/select-match',
    UPRN_CHANGES_CLEAR_MATCH: '/products/uprn-changes/clear-match',
    UPRN_CHANGES_UPDATE_OUTCOMES: '/products/uprn-changes/update-outcomes',
    UPRN_CHANGES_VERIFY_ASSURANCE: '/products/uprn-changes/verify-assurance',
    UPRN_CHANGES_VERIFY_ASSURANCE_UPDATES: '/products/uprn-changes/verify-assurance-updates',
    //
    UPRN_CHANGES_REPORT: '/products/uprn-changes/report',

    //
    MS_NON_ADDRESSABLES_SEARCH_BY_SPID: '/products/ms-non-addressables/search',
    MS_NON_ADDRESSABLES_SEARCH_BY_CORE_SPID: '/products/ms-non-addressables/search-spid',
    MS_NON_ADDRESSABLES_GET_PREMISES: '/products/ms-non-addressables/premises',
    MS_NON_ADDRESSABLES_GET_ADDRESSES: '/products/ms-non-addressables/addresses',
    MS_NON_ADDRESSABLES_GET_VOAS: '/products/ms-non-addressables/voas',
    MS_NON_ADDRESSABLES_GET_CMOS_UPRN: '/products/ms-non-addressables/cmos-uprn',
    MS_NON_ADDRESSABLES_GET_MATCHED_UPRN: '/products/ms-non-addressables/matched-uprn',
    MS_NON_ADDRESSABLES_GET_METER: '/products/ms-non-addressables/meter',
    MS_NON_ADDRESSABLES_GET_SAA: '/products/ms-non-addressables/saa',
    MS_NON_ADDRESSABLES_GET_CT: '/products/ms-non-addressables/ct',
    MS_NON_ADDRESSABLES_MDS_SPID: '/products/ms-non-addressables/mds-spid',
    MS_NON_ADDRESSABLES_MDS_METER: '/products/ms-non-addressables/mds-meter',
    MS_NON_ADDRESSABLES_GET_VO_CT_COMBINED: '/products/ms-non-addressables/voas-ct',
    MS_NON_ADDRESSABLES_LINKED_REFERENCES: '/products/ms-non-addressables/linked-references',
    MS_NON_ADDRESSABLES_VOA_HISTORY: '/products/ms-non-addressables/voa-history',

    // Generics
    MS_NON_ADDRESSABLES_GROUPINGS: '/products/ms-non-addressables/groupings',
    MS_NON_ADDRESSABLES_FILTERS: '/products/ms-non-addressables/filters',
    MS_NON_ADDRESSABLES_DATA: '/products/ms-non-addressables/data',
    MS_NON_ADDRESSABLES_DATES: '/products/ms-non-addressables/dates',
    MS_NON_ADDRESSABLES_FILES: '/products/ms-non-addressables/files',
    MS_NON_ADDRESSABLES_UPLOAD_METERS: '/products/ms-non-addressables/Meters',
    MS_NON_ADDRESSABLES_UPLOAD_SPIDS: '/products/ms-non-addressables/Spids',
    // Workflow
    MS_NON_ADDRESSABLES_WF_USERS: '/products/ms-non-addressables/workflow/users',
    MS_NON_ADDRESSABLES_WF_ITEMS: '/products/ms-non-addressables/workflow',
    MS_NON_ADDRESSABLES_WF_COUNTTS: '/products/ms-non-addressables/workflow-counts',
    // Bulk
    MS_NON_ADDRESSABLES_BULK_BASE: '/products/ms-non-addressables/bulk',
    MS_NON_ADDRESSABLES_BULK_SPIDS: '/products/ms-non-addressables/bulk/spids',
    MS_NON_ADDRESSABLES_BULK_METERS: '/products/ms-non-addressables/bulk/meters',
    MS_NON_ADDRESSABLES_UNALLOCATE_SPIDS: '/products/ms-non-addressables/unallocate/spids',
    MS_NON_ADDRESSABLES_UNALLOCATE_METERS: '/products/ms-non-addressables/unallocate/meters',
    //
    MS_NON_ADDRESSABLES_SUBMIT_NOTES: '/products/ms-non-addressables/submit-notes',
    MS_NON_ADDRESSABLES_SELECT_MATCH: '/products/ms-non-addressables/select-match',
    MS_NON_ADDRESSABLES_CLEAR_MATCH: '/products/ms-non-addressables/clear-match',
    MS_NON_ADDRESSABLES_UPDATE_OUTCOMES: '/products/ms-non-addressables/update-outcomes',
    MS_NON_ADDRESSABLES_VERIFY_ASSURANCE: '/products/ms-non-addressables/verify-assurance',
    MS_NON_ADDRESSABLES_VERIFY_ASSURANCE_UPDATES: '/products/ms-non-addressables/verify-assurance-updates',
    //
    MS_NON_ADDRESSABLES_REPORT: '/products/ms-non-addressables/report',

    //
    VOA_UPDATES_SEARCH: '/products/voa-updates/search',
    VOA_UPDATES_SEARCH_BY_SPID: '/products/voa-updates/search',
    VOA_UPDATES_GET_PREMISES: '/products/voa-updates/premises',
    VOA_UPDATES_GET_ADDRESSES: '/products/voa-updates/addresses',
    VOA_UPDATES_GET_VOAS: '/products/voa-updates/voas',
    VOA_UPDATES_GET_SAA: '/products/voa-updates/saa',
    VOA_UPDATES_GET_CT: '/products/voa-updates/ct',
    VOA_UPDATES_MDS_SPID: '/products/voa-updates/mds-spid',
    VOA_UPDATES_GET_VO_CT_COMBINED: '/products/voa-updates/voas-ct',
    VOA_UPDATES_LINKED_REFERENCES: '/products/voa-updates/linked-references',
    VOA_UPDATES_VOA_HISTORY: '/products/voa-updates/voa-history',
    //
    VOA_UPDATES_GROUPINGS: '/products/voa-updates/groupings',
    VOA_UPDATES_FILTERS: '/products/voa-updates/filters',
    VOA_UPDATES_DATA: '/products/voa-updates/data',
    VOA_UPDATES_DATES: '/products/voa-updates/dates',
    VOA_UPDATES_FILES: '/products/voa-updates/files',
    VOA_UPDATES_UPLOAD_SPIDS: '/products/voa-updates/Spids',
    //
    VOA_UPDATES_WF_USERS: '/products/voa-updates/workflow/users',
    VOA_UPDATES_WF_ITEMS: '/products/voa-updates/workflow',
    VOA_UPDATES_WF_COUNTTS: '/products/voa-updates/workflow-counts',
    //
    VOA_UPDATES_BULK: '/products/voa-updates/bulk',
    VOA_UPDATES_BULK_ALLOCATE: '/products/voa-updates/bulk/allocate',
    VOA_UPDATES_UNALLOCATE: '/products/voa-updates/unallocate',
    //
    VOA_UPDATES_SUBMIT_NOTES: '/products/voa-updates/submit-notes',
    VOA_UPDATES_SELECT_MATCH: '/products/voa-updates/select-match',
    VOA_UPDATES_CLEAR_MATCH: '/products/voa-updates/clear-match',
    VOA_UPDATES_UPDATE_OUTCOMES: '/products/voa-updates/update-outcomes',
    VOA_UPDATES_VERIFY_ASSURANCE: '/products/voa-updates/verify-assurance',
    VOA_UPDATES_VERIFY_ASSURANCE_UPDATES: '/products/voa-updates/verify-assurance-updates',
    //
    VOA_UPDATES_REPORT: '/products/voa-updates/report',

    //
    NEW_SPIDS_SEARCH_BY_SPID: '/products/new-spids/search',
    NEW_SPIDS_GET_PREMISES: '/products/new-spids/premises',
    NEW_SPIDS_GET_ADDRESSES: '/products/new-spids/addresses',
    NEW_SPIDS_GET_VOAS: '/products/new-spids/voas',
    NEW_SPIDS_GET_CMOS_UPRN: '/products/new-spids/cmos-uprn',
    NEW_SPIDS_GET_MATCHED_UPRN: '/products/new-spids/matched-uprn',
    NEW_SPIDS_GET_SAA: '/products/new-spids/saa',
    NEW_SPIDS_GET_CT: '/products/new-spids/ct',
    NEW_SPIDS_MDS_SPID: '/products/new-spids/mds-spid',
    NEW_SPIDS_GET_VO_CT_COMBINED: '/products/new-spids/voas-ct',
    NEW_SPIDS_LINKED_REFERENCES: '/products/new-spids/linked-references',
    NEW_SPIDS_VOA_HISTORY: '/products/new-spids/voa-history',

    // Generics
    NEW_SPIDS_GROUPINGS: '/products/new-spids/groupings',
    NEW_SPIDS_FILTERS: '/products/new-spids/filters',
    NEW_SPIDS_DATA: '/products/new-spids/data',
    NEW_SPIDS_DATES: '/products/new-spids/dates',
    NEW_SPIDS_FILES: '/products/new-spids/files',
    NEW_SPIDS_UPLOAD_SPIDS: '/products/new-spids/Spids',
    // Workflow
    NEW_SPIDS_WF_USERS: '/products/new-spids/workflow/users',
    NEW_SPIDS_WF_ITEMS: '/products/new-spids/workflow',
    NEW_SPIDS_WF_COUNTTS: '/products/new-spids/workflow-counts',
    // Bulk
    NEW_SPIDS_BULK_BASE: '/products/new-spids/bulk',
    NEW_SPIDS_UNALLOCATE_BASE: '/products/new-spids/unallocate',
    //
    NEW_SPIDS_SUBMIT_NOTES: '/products/new-spids/submit-notes',
    NEW_SPIDS_SELECT_MATCH: '/products/new-spids/select-match',
    NEW_SPIDS_UPDATE_OUTCOMES: '/products/new-spids/update-outcomes',
    NEW_SPIDS_VERIFY_ASSURANCE: '/products/new-spids/verify-assurance',
    NEW_SPIDS_VERIFY_ASSURANCE_UPDATES: '/products/new-spids/verify-assurance-updates',
    //
    NEW_SPIDS_REPORT: '/products/new-spids/report',

    //
    UPRN_SEARCH_UPRN: '/products/uprn-search/uprn',
    UPRN_SEARCH_SUGGESTIONS: '/products/uprn-search/suggestions',
    UPRN_SEARCH_ADDRESS: '/products/uprn-search/address',
    UPRN_SEARCH_POSTCODE: '/products/uprn-search/postcode',
    UPRN_SEARCH_COORDINATES: '/products/uprn-search/coordinates',
    UPRN_SEARCH_VOA: '/products/uprn-search/voa',

    //
    SERVICE_COMPONENTS_SEARCH: '/products/service-components/search',
    SERVICE_COMPONENTS_POSTCODE_SEARCH: '/products/service-components/postcode-search',
    SERVICE_COMPONENTS_UPDATE: '/products/service-components/update',
    SERVICE_COMPONENTS_WORKFLOW_ITEMS: '/products/service-components/workflow-items',
    SERVICE_COMPONENTS_EXCLUDE: '/products/service-components/exclude',

    WORKFLOW_REPORTS_DATA: '/products/workflow-reports/data',
    WORKFLOW_REPORTS_EXCEL_DATA: '/products/workflow-reports/excel-data',
    WORKFLOW_REPORTS_USERS: '/products/workflow-reports/users',

    COMPANY_ADMIN_USERS: '/company-admin/users',

    ADMIN_COMPANIES_INDEX: '/companies',
    ADMIN_COMPANIES_COMPANY: '/companies',

    ADMIN_WHOLESALERS: '/wholesaler',
    ADMIN_RETAILERS: '/retailer',

    ADMIN_EXTRA_PERMISSIONS: '/extra-permissions',

    ADMIN_COMPANIES_COMPANY_FRONTEND: '/frontends',

    ADMIN_COMPANIES_USERS: '/users',
    ADMIN_COMPANIES_USER: '/users',

    ADMIN_USERS_INDEX: '/users',

    ADMIN_BRANDING_INDEX: '/branding',
    ADMIN_BRANDING_POST: '/branding',

    ADMIN_PRODUCTS_INDEX: '/products',
    ADMIN_PRODUCTS_UPDATE_TUTORIALS: '/tutorials/update-tutorials',
    ADMIN_REAL_PRODUCTS_INDEX: '/real-products',

    ADMIN_VERSION_HISTORY_CHANGES: '/version-history/changes',
    ADMIN_VERSION_HISTORY_VERSION_NUMBERS: '/version-history/versions',
    ADMIN_VERSION_HISTORY_INSERT: '/version-history/insert-changes',
    ADMIN_VERSION_HISTORY_EDIT: '/version-history/edit',
    ADMIN_VERSION_HISTORY_DELETE: '/version-history/delete',
    ADMIN_VERSION_HISTORY_SEEN_CHANGES: '/version-history/seen-changes',
    ADMIN_VERSION_HISTORY_RECENT_DATE: '/version-history/recent-date',

    ADMIN_ALIGN_ENVIRONMENTS: '/data-alignment',

    RESET_REQUEST: '/auth/reset/request',
    RESET_CHECK: '/auth/reset/check',
    RESET_RESET: '/auth/reset',
});
